import { parseDate } from "@internationalized/date";
import PropTypes from "prop-types";

import DatePickerMain from "shared/components/date-controls/date-picker/DatePickerMain";
import FormInputWrapper from "shared/components/inputs/form/FormInputWrapper";
import { useFormInput } from "shared/components/inputs/form-fields/utils";

const DatePicker = ({
    defaultDateValue = null,
    name,
    validations,
    label = "",
    description,
    helpText,
    className,
    ...rest
}) => {
    const { wrapperProps, inputProps } = useFormInput({
        name,
        validations,
        isControlled: true,
    });

    const internalValue = inputProps.value ? parseDate(inputProps.value) : null;

    const internalOnChange = (dateValue) => {
        inputProps.onChange(dateValue ? dateValue.toLocaleString() : null);
    };

    return (
        <FormInputWrapper
            {...{ label, description, helpText, className }}
            {...wrapperProps}
        >
            <DatePickerMain
                {...rest}
                defaultValue={defaultDateValue}
                label={label}
                feedbackType={inputProps.feedbackType}
                dateOnChange={internalValue}
                onChange={internalOnChange}
            />
        </FormInputWrapper>
    );
};

DatePicker.propTypes = {
    defaultDateValue: PropTypes.object,
    name: PropTypes.string.isRequired,
    validations: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    helpText: PropTypes.string,
    className: PropTypes.string,
};

export default DatePicker;
